import angular from 'angular'
import ngRoute from 'angular-route'
import * as initialLoad from './initialLoads'
import { hasPermission } from '../services/permission'

// used for multiple story routes
const storyRoute = {
  template: '<story></story>',
  reloadOnSearch: true,
  resolve: {
    initialSettingsLoad: initialLoad.settings,
    initialStoryLoad: initialLoad.story,
    initialLockState: initialLoad.lockState,
    initialDistributors: initialLoad.distributorList,
    // todo: daniel: we dont need this here, but...race conditions
    initialPicklistLoad: initialLoad.picklist,
    initialTagsSettingsLoad: initialLoad.tagsSettings,
    initialWebsiteLoad: initialLoad.websites,
    initialWebskedLoad: initialLoad.websked,
  },
}

const storyDraftjsRoute = {
  template: '<draft-editor></draft-editor>',
  reloadOnSearch: true,
  isDraftApp: true,
  resolve: {
    initialSettingsLoad: initialLoad.settings,
    initialStoryLoad: initialLoad.story,
    initialLockState: initialLoad.lockState,
    initialDistributors: initialLoad.distributorList,
    initialPicklistLoad: initialLoad.picklist,
    initialTagsSettingsLoad: initialLoad.tagsSettings,
    initialWebsiteLoad: initialLoad.websites,
    initialWebskedLoad: initialLoad.websked,
  },
}

// Template Route
const templateRoute = {
  template: '<story></story>',
  reloadOnSearch: false,
  resolve: {
    initialSettingsLoad: initialLoad.settings,
    initialStoryLoad: initialLoad.template,
    initialLockState: initialLoad.lockState,
    initialDistributors: initialLoad.distributorList,
    initialPicklistLoad: initialLoad.picklist,
    initialTagsSettingsLoad: initialLoad.tagsSettings,
    initialWebsiteLoad: initialLoad.websites,
    initialWebskedLoad: initialLoad.websked,
  },
}

export default angular
  .module('ellipsis.routes', [ngRoute])
  .config(function (toastrConfig) {
    angular.extend(toastrConfig, {
      autoDismiss: true,
      containerId: 'toast-container',
      maxOpened: 0,
      positionClass: 'toast-bottom-full-width',
      newestOnTop: 'true',
      preventDuplicates: false,
      target: 'body',
    })
  })
  .config([
    '$routeProvider',
    '$locationProvider',
    ($routeProvider, $locationProvider) => {
      $routeProvider
        .when('/', {
          redirectTo: '/search',
        })
        .when('/picklist/:picklistId', {
          reloadOnSearch: false,
          title: 'picklist',
          template: `<picklist></picklist>`,
          resolve: {
            initialPicklistLoad: initialLoad.picklist,
          },
        })
        .when('/search', {
          template: '<search></search>',
          title: 'search',
          reloadOnSearch: false,
          resolve: {
            initialSettingsLoad: initialLoad.settings,
            initialWebskedLoad: initialLoad.websked,
          },
        })
        .when('/search/:id', {
          template: '<search></search>',
          title: 'search',
          resolve: {
            initialSettingsLoad: initialLoad.settings,
            initialWebskedLoad: initialLoad.websked,
          },
        })
        .when('/storyold/:id/', storyRoute)
        .when('/story/:id/', storyDraftjsRoute)
        .when('/story/:id/revision', {
          ...storyRoute,
          navigateToRevision: true,
        })
        .when('/edit/:id/', storyDraftjsRoute)
        .when('/story/:id/revision/:revision/', storyRoute)
        .when('/storyold', storyRoute)
        .when('/story', storyDraftjsRoute)
        .when('/template', templateRoute)
        .when('/template/:id/', templateRoute)
        .when('/settings', {
          template: '<settings></settings>',
          title: 'settings',
          resolve: {
            reloadSettings: initialLoad.reloadSettings,
            securityCheck: ($q, $location) => {
              const deferred = $q.defer()
              if (hasPermission(window.userRolesAuth.story.settings)) {
                deferred.resolve()
              } else {
                deferred.reject()
                $location.path('/search')
              }
              return deferred.promise
            },
          },
        })
        .when('/templates', {
          template: '<templates></templates>',
          title: 'templates',
          resolve: {
            reloadSettings: initialLoad.reloadSettings,
            securityCheck: ($q, $location) => {
              const deferred = $q.defer()
              if (hasPermission(window.userRolesAuth.story.templates)) {
                deferred.resolve()
              } else {
                deferred.reject()
                $location.path('/search')
              }
              return deferred.promise
            },
          },
        })
        .when('/noAccess', {
          template: '<noaccess></noaccess>',
        })
        .when('/storyNotFound/:id', {
          template: '<story-not-found></story-not-found>',
        })
        .when('/storyAccessDenied/:id', {
          template: '<story-access-denied></story-access-denied>',
        })
        .otherwise({
          redirectTo: '/',
        })
      $locationProvider.hashPrefix('!')
      $locationProvider.html5Mode({
        enabled: true,
        requireBase: true,
      })
    },
  ])
  .run([
    '$rootScope',
    '$route',
    'uiStateManagerMonitorService',
    ($rootScope, $route, uiStateManagerMonitorService) => {
      $rootScope.$on('$routeChangeSuccess', () => {
        $('.tooltip').hide()
        if ($route.current.title) {
          document.title = `Composer | ${$route.current.title}`
        }
      })
      uiStateManagerMonitorService.register() // safe to call multiple times.
    },
  ])
  .run([
    '$rootScope',
    'monitoringService',
    'pharosService',
    ($rootScope, monitoringService, pharosService) => {
      monitoringService.init()
      pharosService.initSentryConnection()
    },
  ])
